import React from "react";
import logo from "../assets/logo.png";
import {useAuth0} from "@auth0/auth0-react";
import {Nav, NavItem, NavLink} from "reactstrap";
import {NavLink as RouterNavLink} from "react-router-dom";
import leadHeroImage from "../assets/undraw_relaxed-reading_wfkr.svg";

const Hero = () => {
    const {isAuthenticated} = useAuth0();

    return (
        <div className="text-center hero my-5">

            <div>
                <img src={logo} alt="logo" width="365" height="170"/>
            </div>

            <p className="lead">
                Discover, enjoy and track your favorite books and audiobooks.
            </p>

            <p className="lead">
                <img src={leadHeroImage} alt="" width='100%'/>
            </p>

            {isAuthenticated && (
                <Nav className="mr-auto" navbar style={{boxShadow: "none", flexDirection: "row"}}>
                    <NavItem style={{width: "50%"}}>
                        <NavLink
                            tag={RouterNavLink}
                            to="/search"
                            exact
                            style={{margin: "0", padding: "0"}}
                            activeClassName="router-link-exact-active"
                        >
                            <button className="btn btn-primary" style={{borderRadius: "10px", background: "#2553c5"}}>Search</button>
                        </NavLink>
                    </NavItem>
                    <NavItem style={{width: "50%"}}>
                        <NavLink
                            tag={RouterNavLink}
                            to="/profile"
                            exact
                            style={{margin: "0", padding: "0"}}
                            activeClassName="router-link-exact-active"
                        >
                            <button className="btn btn-primary" style={{borderRadius: "10px", background: "#2553c5"}}>My Library</button>
                        </NavLink>
                    </NavItem>
                </Nav>
            )}

        </div>
    )
};

export default Hero;
